module.exports = __webpack_public_path__ + "img/icon-access.19ab6675.svg";